export const normalizeMeetingForRealtime = (meetingData, voiceId) => {
  if (!meetingData) return null;

  return {
    ...meetingData,
    meetingType: meetingData.customMeeting || meetingData.meetingType || "Practice Session",
    industry:
      meetingData.industry === "custom"
        ? meetingData.customIndustry
        : meetingData.industry || "N/A",
    userRole:
      meetingData.userRole === "custom"
        ? meetingData.customRole
        : meetingData.userRole || "participant",
    speakingWith:
      meetingData.speakingWith === "custom"
        ? meetingData.customSpeakingWith
        : meetingData.speakingWith || "meeting participant",
    languageLabel: meetingData.languageLabel || "English",
    aiVoice: voiceId || meetingData.aiVoice || "cedar",
    goals: Array.isArray(meetingData.goals) ? meetingData.goals : [],
    customGoals: Array.isArray(meetingData.customGoals) ? meetingData.customGoals : [],
    duration: meetingData.duration || 10,
    additionalInfo: meetingData.additionalInfo || "",
    documentContext: meetingData.documentContext || "",
  };
};
